import { Patient } from 'api/account/patients.type';
import { useCreateLeadFromMember } from 'hooks/useCreateLeadFromMember';
import { useNavigate } from 'react-router-dom';

import ChooseMember from './ChooseMember';

const CoreChooseMember = () => {
  const nav = useNavigate();
  const createLeadFromMember = useCreateLeadFromMember();
  const handleNewMember = () => {
    nav('/account/add-member');
  };
  const handleNextClick = (member: Patient) => {
    if (member.unfinishedCoreOnboarding) {
      nav(`/account/exclusion/${member.id}/core`);
    } else {
      createLeadFromMember
        .mutateAsync({ memberId: member.id, leadType: 'CC' })
        .then(() => {
          nav(`/account/exclusion/${member.id}/core`);
        })
        .catch((error) => {
          console.error('Error creating lead from member:', error);
        });
    }
  };
  return (
    <ChooseMember
      type="core"
      title="Who would you like to add behavioral care for?"
      handleNewMember={handleNewMember}
      handleNextClick={handleNextClick}
    />
  );
};

export default CoreChooseMember;
